<script setup lang="ts">
import { useFormContainer } from "~/composables/useFormContainer";
import RadioButton from "~/components/inputs/RadioButton.vue";
import FormCard from "~/components/ui/FormCard.vue";
import BaseForm from "~/components/ui/BaseForm.vue";
import ProgressBar from "~/components/ui/ProgressBar.vue";
import BackButton from "~/components/inputs/BackButton.vue";
import Accordion from "~/components/ui/Accordion.vue";

import Validator from "~/utils/validator";

import { useVuelidate } from "@vuelidate/core";
const locale = await getLocale("forms", "employee_loan");
import employeeLoanRules from "~/rules/employeeLoan";

defineComponent({
  name: "EmployeeLoan",
});

defineProps({
  progress: { type: Number, required: true },
  title: { type: String, required: true },
});

const { FormContainer } = useFormContainer();

const emit = defineEmits(["init", "submit", "goBack"]);

const employeeLoan = useState<boolean | null>("employeeLoan", () => null);

const v$ = useVuelidate(employeeLoanRules, { employeeLoan });

const validate = () => {
  v$.value.$touch();
  v$.value.$validate();
  return !v$.value.$error;
};

const submit = () => {
  if (validate()) {
    emit("submit");
  }
};
onMounted(() => emit("init"));
</script>

<template>
  <FormContainer :progress="progress">
    <FormCard :title="locale.title" @submit="submit">
      <div class="w-full mb-4">
        <div class="flex mt-8 justify-center sm:justify-start">
          <RadioButton
            v-model="employeeLoan"
            :values="yesNoOptions"
            :error="v$.employeeLoan.$error"
            :error-message="Validator.message(v$.employeeLoan)"
            data-testid="employeeLoan"
          />
        </div>
      
        <Accordion>
          <p class="flex justify-center sm:justify-start w-full">
            <span class="text-center md:text-left text-sm" v-html="locale.cdq_definition" />
          </p>
          <template #items>
            <!-- class="py-5 text-gray-600 border-t border-b mt-5" -->
            <div class="yellowBox mt-5" v-html="locale.cdq_explanation" />
          </template>
        </Accordion>
      </div>
      <template #link>
        <BackButton :event="`goBack`" @go-back="$emit('goBack')" />
      </template>
    </FormCard>
  </FormContainer>
</template>

<style scoped></style>
